export enum LobbyActionType {
  SELECT_GAME,
  START_GAME,
  KICK_USER,
  PROMOTE_LEADER,
  DEMOTE_LEADER,
  SUGGEST_GAME,
}

export interface LobbyActionStructure {
  type: LobbyActionType;
  data: unknown;
}

export interface GameSelection extends LobbyActionStructure {
  type: LobbyActionType.SELECT_GAME;
  data: {
    gameUniqueName: string;
  };
}

export interface GameSuggestion extends LobbyActionStructure {
  type: LobbyActionType.SUGGEST_GAME;
  data: {
    gameUniqueName: string;
  };
}

export interface StartGame extends LobbyActionStructure {
  type: LobbyActionType.START_GAME;
  data: unknown;
}

export interface KickUserAction extends LobbyActionStructure {
  type: LobbyActionType.KICK_USER;
  data: {
    userId: string;
    reason?: string;
  };
}

export interface PromoteLeader extends LobbyActionStructure {
  type: LobbyActionType.PROMOTE_LEADER;
  data: {
    uuid: string;
  };
}

export interface DemoteLeader extends LobbyActionStructure {
  type: LobbyActionType.DEMOTE_LEADER;
  data: {
    uuid: string;
  };
}

export type LobbyAction =
  | GameSelection
  | GameSuggestion
  | StartGame
  | KickUserAction
  | PromoteLeader
  | DemoteLeader;
